export default __webpack_public_path__ + "justhatched-third-screens_small.0b983272.png";